import { Input, BoxInput, IBoxCardSizes, IBoxInputAlignment, IBoxInputTypes } from '@repo/apg-ui';
import React, { ReactElement, useEffect, useState } from 'react';
import { RootState } from '../../reducers';
import { bindActionCreators, Dispatch } from 'redux';
import * as actions from '../../actions';
import * as _actionsFilters from '../../actions/filters';
import { withRouter } from '../../utils/withRouter';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { KitIcons } from '@repo/apg-ui';
import classNames from 'classnames';
import { SchemaIndustry } from '@repo/legacy-commerce-api';

interface Props {
  actionsFilters?: typeof _actionsFilters;
  industriesByKey?: any;
  userDataEC?: any;
  big5Industries?: Record<string, SchemaIndustry>;
  industries?: SchemaIndustry[];
  isShowIcons?: boolean;
  onSelect?: any;
  notAllowedElement?: any;
  notAllowed?: any;
  cardSize?: IBoxCardSizes;
}

const _IndustriesSelect = ({
  actionsFilters,
  userDataEC,
  big5Industries,
  industries,
  isShowIcons,
  onSelect,
  notAllowedElement,
  notAllowed,
  cardSize,
}: Props) => {
  const [industry, setIndustry] = useState<string>();
  const [moreIndustriesVisible, setMoreIndustriesVisible] = useState(false);
  const [alcoholIndustries, setAlcoholIndustries] = useState<SchemaIndustry[]>([]);
  const ALCOHOL_CODE = '150.02';

  useEffect(() => {
    actionsFilters
      .fetchIndustries({
        context: 'alcohol',
        basket: userDataEC.basketInfo?.basket,
        basketreference: userDataEC.basketInfo?.basketreference,
      })
      .then((res: SchemaIndustry[]) => {
        setAlcoholIndustries(res);
        setMoreIndustriesVisible(industry === '150.02');
      });
    setIndustry(userDataEC.industry);
  }, []);

  const showIndustryOptions = (industry: string) => {
    if (industry !== ALCOHOL_CODE) {
      setIndustry(industry);
      actionsFilters.updateIndustry(industry);
      onSelect && onSelect();
    } else {
      setMoreIndustriesVisible(true);
    }
  };

  const prepareBig5IndustriesOptions = (industries: { [x: string]: SchemaIndustry }) => {
    const industriesList: string[] = industries ? Object.keys(industries) : [];
    const industriesOptions: {
      title: string;
      text: string;
      icon: ReactElement;
      value: string;
      labelChildren: any;
      children?: any;
      disabled: boolean;
      hasChildren?: boolean;
    }[] = [];
    const alcoholOptions = [];

    if (isEmpty(industriesList)) {
      return industriesOptions;
    }

    const politicsCode = industriesList.filter((ind: string) => industries[ind].icon === 'politics')[0];
    const alcoholCode = industriesList.filter((ind: string) => industries[ind].icon === 'alcohol')[0];
    const politicsIndustry = industries[politicsCode];
    const alcoholIndustry = industries[alcoholCode];

    for (const subindustry of alcoholIndustries) {
      alcoholOptions.push({
        title: subindustry.value,
        text: subindustry.additionalinfos,
        icon: KitIcons.industryIcons[alcoholIndustry.icon as keyof typeof KitIcons.industryIcons],
        value: subindustry.id,
        labelChildren: notAllowedElement,
        disabled: (notAllowed || []).includes(subindustry.id),
      });
    }

    industriesOptions.push(
      {
        title: politicsIndustry.value,
        text: politicsIndustry.additionalinfos,
        icon: KitIcons.industryIcons[politicsIndustry.icon as keyof typeof KitIcons.industryIcons],
        value: politicsIndustry.id,
        labelChildren: notAllowedElement,
        disabled: (notAllowed || []).includes(politicsIndustry.id),
      },
      {
        title: alcoholIndustry.value,
        text: alcoholIndustry.additionalinfos,
        icon: KitIcons.industryIcons[alcoholIndustry.icon as keyof typeof KitIcons.industryIcons],
        value: alcoholIndustry.id,
        hasChildren: true,
        children: alcoholOptions,
        labelChildren: notAllowedElement,
        disabled: (notAllowed || []).includes(alcoholIndustry.id),
      },
    );

    industriesList.forEach((industry) => {
      const industr = industries[industry];
      const isDisabled = (notAllowed || []).includes(industr.id);
      const industriesObj = {
        title: industr.value,
        text: industr.additionalinfos,
        icon: KitIcons.industryIcons[industr.icon as keyof typeof KitIcons.industryIcons],
        value: industr.id,
        labelChildren: notAllowedElement,
        disabled: isDisabled,
      };

      if (industry !== politicsCode && industry !== alcoholCode) {
        industriesOptions.push(industriesObj);
      }
    });

    return industriesOptions;
  };

  const prepareIndustriesOptions = (industries: SchemaIndustry[]) => {
    return industries
      ? industries.map((industry: SchemaIndustry) => {
          return {
            label: industry.value,
            type: 'radio',
            name: 'industry',
            value: industry.id,
            disabled: (notAllowed || []).includes(industry.id),
            onChange: (name: string, _industry: string) => {
              setIndustry(_industry);
              actionsFilters.updateIndustry(_industry);
              onSelect && onSelect();
            },
          };
        })
      : [];
  };
  return (
    <BoxInput
      id='advertising-input'
      options={prepareBig5IndustriesOptions(big5Industries)}
      selected={industry}
      type={IBoxInputTypes.Radio}
      alignment={IBoxInputAlignment.TwoColumns}
      size={cardSize ? cardSize : IBoxCardSizes.SmallCard}
      isShowIcons={isShowIcons}
      moreIndustriesVisible={
        moreIndustriesVisible ? (
          <>
            <div className={'box-input-label-fake empty-block'}></div>
            <div
              className={classNames('branches-wrapper box-input-label-fake', {
                'small-size': cardSize === IBoxCardSizes.SmallCard,
                'normal-size': cardSize === IBoxCardSizes.NormalCard,
              })}
            >
              <Input
                readOnly={false}
                forcedValue={industry}
                radioOptions={prepareIndustriesOptions(industries)}
              ></Input>
            </div>
          </>
        ) : null
      }
      onChange={(industry: string) => showIndustryOptions(industry)}
    />
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    dispatch: dispatch,
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(_IndustriesSelect));
